import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "../api.service";

const PATH = "account-app-instruments";

@Injectable({
  providedIn: "root",
})
export class AccountAppInstrumentationHandlerService {
  constructor(private APIService: ApiService) {}

  getAccountAppInstruments(
    masterAccountID: number,
    appID: number,
  ): Observable<any[]> {
    return this.APIService.get(
      `${PATH}/${masterAccountID}/${appID}`,
    ) as unknown as Observable<any[]>;
  }

  getAccountAppInstrument(
    masterAccountID: number,
    appID: number,
    instrumentID: number,
    startDate: Date,
    endDate: Date,
    compareDays: number,
  ) {
    return this.APIService.get(
      `${PATH}/${masterAccountID}/${appID}/${instrumentID}?start=${startDate.toISOString()}&end=${endDate.toISOString()}&compare_days=${compareDays}`,
    );
  }

  deleteAppInstrument(
    masterAccountID: number,
    appID: number,
    instrumentID: number,
  ) {
    return this.APIService.delete(
      `${PATH}/${masterAccountID}/${appID}/${instrumentID}`,
    );
  }

  createAppInstrument(
    masterAccountID: number,
    appID: number,
    appInstrumentDTO: any,
  ) {
    return this.APIService.post(
      `${PATH}/${masterAccountID}/${appID}`,
      appInstrumentDTO,
    );
  }
}
